import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackbarService } from 'app/core/snackbars/snackbar.service';
import { UsersResponse, UsersFilter, RecentlyPlayedWithUser } from './users.types';

@Injectable()
export class UsersService {
    constructor(
        private _httpClient: HttpClient,
        private _snackbarService: SnackbarService
    ) {}

    getUsers = (filters: UsersFilter): Observable<UsersResponse> => {
        let params = new HttpParams();
        
        // Add pagination parameters
        params = params.set('PageNumber', filters.pageNumber?.toString() || '1');
        params = params.set('PageSize', filters.pageSize?.toString() || '20');
        
        // Add sorting parameters
        if (filters.sortBy) {
            params = params.set('SortBy', filters.sortBy);
        }
        if (filters.sortDirection) {
            params = params.set('SortDirection', filters.sortDirection);
        }
        
        // Add search parameter
        if (filters.search) {
            params = params.set('Search', filters.search);
        }
        
        // Add isAdmin parameter
        if (filters.isAdmin !== undefined) {
            params = params.set('IsAdmin', filters.isAdmin.toString());
        }

        return this._httpClient.get<UsersResponse>('api/Users', { params }).pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            })
        );
    };

    getRecentlyPlayedWith = (): Observable<RecentlyPlayedWithUser[]> =>
        this._httpClient.get<RecentlyPlayedWithUser[]>('api/Users/recently-played-with').pipe(
            catchError((err, _) => {
                this._snackbarService.error(err);
                throw err;
            })
        );
}